/**
 * Project-member invite status constants.
 * Mirrors the backend `project_members.invite_status` ENUM. A `null` status
 * means the member was never invited (a provisional / uninvited row).
 */

export const INVITE_STATUS = {
	PENDING: "PENDING",
	ACCEPTED: "ACCEPTED",
};

/**
 * A member actively participates in the project only once they have ACCEPTED
 * their invite. PENDING (invited, not yet accepted) and null (never invited)
 * are not active participants.
 * @param {object} member - project member row (expects `inviteStatus`)
 * @returns {boolean}
 */
export const isInviteAccepted = (member) =>
	member?.inviteStatus === INVITE_STATUS.ACCEPTED;

export default INVITE_STATUS;
